import { v4 as uuid } from "uuid";

import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { Conditional, Expression, FilterQuery } from "shared";

export const getDefaultFiltersParams = (
  quoteRequestLine: QuoteRequestLineDto | undefined | null,
) => {
  if (!quoteRequestLine) {
    return {
      filterGroup: {
        conditional: "AND" as Conditional,
        expressions: [],
      },
    };
  }

  const quantities = getQuantities(quoteRequestLine.quantity);

  const defaultFiltersParams: FilterQuery = {
    filterGroup: {
      conditional: "AND" as Conditional,
      expressions: [
        {
          id: uuid(),
          property: "dimensions",
          operator: "NEAR",
          value: 50,
        },
        {
          id: uuid(),
          property: "materialGrade",
          operator: "EQUAL",
          value: quoteRequestLine.materialGrade,
        },
        ...quantities,
      ],
    },
  };

  return defaultFiltersParams;
};

type QuantityRange = {
  min: number;
  max: number | null;
  searchMin: number;
  searchMax: number | null;
};

const QUANTITY_RANGES: QuantityRange[] = [
  { min: 0, max: 9, searchMin: 0, searchMax: 20 },
  { min: 10, max: 99, searchMin: 10, searchMax: 100 },
  { min: 100, max: 999, searchMin: 100, searchMax: 1000 },
  { min: 1000, max: null, searchMin: 500, searchMax: null },
];

const getQuantities = (quantity: number | null): Expression[] => {
  if (!quantity) {
    return [];
  }

  const foundRange = QUANTITY_RANGES.find(
    (range) => quantity >= range.min && (!range.max || quantity <= range.max),
  );

  if (!foundRange) {
    return [];
  }

  return [
    {
      id: uuid(),
      property: "quantity",
      operator: "GREATER_THAN_OR_EQUAL",
      value: foundRange.searchMin,
    },
    {
      id: uuid(),
      property: "quantity",
      operator: "LESS_THAN",
      value: foundRange.searchMax,
    },
  ];
};
